export default "__VITE_ASSET__BqXr5Wsv__"